import { CommonModule } from '@angular/common';
import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import {
  ControlValueAccessor,
  FormControl,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { ButtonsModule } from '@progress/kendo-angular-buttons';
import { InputsModule } from '@progress/kendo-angular-inputs';

@Component({
  selector: 'app-file-input',
  templateUrl: './file-input.component.html',
  styleUrls: ['./file-input.component.scss'],
  standalone: true,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: FileInputComponent,
      multi: true,
    },
  ],
  imports: [CommonModule, ReactiveFormsModule, InputsModule, ButtonsModule],
})
export class FileInputComponent implements OnInit, ControlValueAccessor {
  @Input() label: string = 'label';
  @Input() displayValue = null;
  @ViewChild('fileInput') fileInputRef:
    | ElementRef<HTMLInputElement>
    | undefined;

  public file: File | undefined;
  

  private onChange = (val: any) => {};
  private onTouch = () => {};

  constructor() {}
  writeValue(obj: any): void {
    this.file = obj;
  }
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouch = fn;
  }

  ngOnInit(): void {}

  clear() {
    this.file = undefined;
    if (this.fileInputRef) {
      this.fileInputRef.nativeElement.value = '';
      this.fileInputRef.nativeElement.files = null;
      this.onChange(null);
    }
  }

  onFileChange(ev: Event) {
    if (ev.target) {
      const file = (ev.target as HTMLInputElement).files?.item(0);
      console.log(file);
      if (file) {
        this.file = file;
        this.onChange(file);
      }
    }
  }
}
